"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _ActionStore2 = require("../../../higher-order/ActionStore");

var _clientErrorLogger = _interopRequireDefault(require("../../../util/clientErrorLogger"));

var _ModalModel2 = _interopRequireDefault(require("../../../gradifui/models/ModalModel"));

var _SessionModel = _interopRequireDefault(require("./SessionModel"));

var _class, _descriptor, _class3, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var SessionExpiringModalModel = (_class = /*#__PURE__*/function (_ModalModel) {
  _inherits(SessionExpiringModalModel, _ModalModel);

  var _super = _createSuper(SessionExpiringModalModel);

  function SessionExpiringModalModel() {
    var _this;

    _classCallCheck(this, SessionExpiringModalModel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_assertThisInitialized(_this), "remainingTime", _descriptor, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(SessionExpiringModalModel, [{
    key: "constuctor",
    value: function constuctor(isOpen, remainingTime) {
      this.isOpen = isOpen;
      this.remainingTime = remainingTime;
    }
  }]);

  return SessionExpiringModalModel;
}(_ModalModel2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "remainingTime", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
})), _class);
var SessionStore = (_class3 = /*#__PURE__*/function (_ActionStore) {
  _inherits(SessionStore, _ActionStore);

  var _super2 = _createSuper(SessionStore);

  function SessionStore(props, dispatcher) {
    var _props$session$featur, _props$session, _props$session$extern, _props$session2, _props$environment;

    var _this2;

    _classCallCheck(this, SessionStore);

    _this2 = _super2.call(this, dispatcher);

    _initializerDefineProperty(_assertThisInitialized(_this2), "session", _descriptor2, _assertThisInitialized(_this2));

    _initializerDefineProperty(_assertThisInitialized(_this2), "expiringModal", _descriptor3, _assertThisInitialized(_this2));

    _initializerDefineProperty(_assertThisInitialized(_this2), "featureToggles", _descriptor4, _assertThisInitialized(_this2));

    _initializerDefineProperty(_assertThisInitialized(_this2), "externalUrls", _descriptor5, _assertThisInitialized(_this2));

    _initializerDefineProperty(_assertThisInitialized(_this2), "environment", _descriptor6, _assertThisInitialized(_this2));

    _this2.session = new _SessionModel.default(props.session);
    _this2.expiringModal = new SessionExpiringModalModel(false, 0);
    _this2.featureToggles = (_props$session$featur = (_props$session = props.session) === null || _props$session === void 0 ? void 0 : _props$session.featureToggles) !== null && _props$session$featur !== void 0 ? _props$session$featur : {};
    _this2.externalUrls = (_props$session$extern = (_props$session2 = props.session) === null || _props$session2 === void 0 ? void 0 : _props$session2.externalUrls) !== null && _props$session$extern !== void 0 ? _props$session$extern : {};
    _this2.environment = (_props$environment = props.environment) !== null && _props$environment !== void 0 ? _props$environment : "LOCAL"; // update Sentry/Raven with session id and user id

    if (props.session) {
      var _props$session3, _props$session3$user;

      if (props.session.id) {
        _clientErrorLogger.default.setSessionId(props.session.id);
      }

      if ((_props$session3 = props.session) !== null && _props$session3 !== void 0 && (_props$session3$user = _props$session3.user) !== null && _props$session3$user !== void 0 && _props$session3$user.altId) {
        _clientErrorLogger.default.setUserId(props.session.user.altId);
      }
    }

    return _this2;
  }

  _createClass(SessionStore, [{
    key: "employerFeatures",
    get: function get() {
      var _this$session$feature, _this$session, _this$session$feature2;

      return (_this$session$feature = (_this$session = this.session) === null || _this$session === void 0 ? void 0 : (_this$session$feature2 = _this$session.features) === null || _this$session$feature2 === void 0 ? void 0 : _this$session$feature2.employer) !== null && _this$session$feature !== void 0 ? _this$session$feature : {};
    }
  }, {
    key: "memberFeatures",
    get: function get() {
      var _this$session$feature3, _this$session2, _this$session2$featur;

      return (_this$session$feature3 = (_this$session2 = this.session) === null || _this$session2 === void 0 ? void 0 : (_this$session2$featur = _this$session2.features) === null || _this$session2$featur === void 0 ? void 0 : _this$session2$featur.member) !== null && _this$session$feature3 !== void 0 ? _this$session$feature3 : {};
    }
  }, {
    key: "unreadNotificationCount",
    get: function get() {
      var _this$session$unreadN, _this$session3;

      return (_this$session$unreadN = (_this$session3 = this.session) === null || _this$session3 === void 0 ? void 0 : _this$session3.unreadNotificationCount) !== null && _this$session$unreadN !== void 0 ? _this$session$unreadN : 0;
    }
  }, {
    key: "notificationCount",
    get: function get() {
      var _this$session$notific, _this$session4;

      return (_this$session$notific = (_this$session4 = this.session) === null || _this$session4 === void 0 ? void 0 : _this$session4.notificationCount) !== null && _this$session$notific !== void 0 ? _this$session$notific : 0;
    }
  }, {
    key: "logout",
    value: function logout(e) {
      var logoutUrl = "/logout".concat(e.data.redirectUrl ? "?redirectUrl=" + e.data.redirectUrl : "");
      window.location.assign(logoutUrl);
    }
  }, {
    key: "sessionExtend",
    value: function sessionExtend(e) {
      var _this$session5;

      (_this$session5 = this.session) === null || _this$session5 === void 0 ? void 0 : _this$session5.restart(this.dispatcher);
      this.dispatcher.emit("HIDE_SESSION_EXPIRING_MODAL");
      this.dispatcher.emit("LOAD_SESSION_DATA", {
        forceRefresh: true
      });
    }
  }, {
    key: "sessionExpiring",
    value: function sessionExpiring(e) {
      this.expiringModal.remainingTime = e.data.remainingTime;
      this.expiringModal.open();
    }
  }, {
    key: "sessionExpired",
    value: function sessionExpired(e) {
      var _this$session$loginPa, _this$session6;

      this.dispatcher.emit("DISABLE_NAVIGATION_WARNING_MODAL");
      this.dispatcher.emit("LOGOUT", {
        redirectUrl: (_this$session$loginPa = (_this$session6 = this.session) === null || _this$session6 === void 0 ? void 0 : _this$session6.loginPath) !== null && _this$session$loginPa !== void 0 ? _this$session$loginPa : "" + "?errorCode=3"
      });
    }
  }, {
    key: "hideSessionExpiringModal",
    value: function hideSessionExpiringModal(e) {
      this.expiringModal.close();
    }
  }, {
    key: "loadSessionData",
    value: function loadSessionData(e) {
      var _this$session7;

      (_this$session7 = this.session) === null || _this$session7 === void 0 ? void 0 : _this$session7.loadFromServer(this.dispatcher, e.data.forceRefresh);
    }
  }]);

  return SessionStore;
}(_ActionStore2.ActionStore), (_descriptor2 = _applyDecoratedDescriptor(_class3.prototype, "session", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, "expiringModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "featureToggles", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "externalUrls", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "environment", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class3.prototype, "employerFeatures", [_mobx.computed], Object.getOwnPropertyDescriptor(_class3.prototype, "employerFeatures"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "memberFeatures", [_mobx.computed], Object.getOwnPropertyDescriptor(_class3.prototype, "memberFeatures"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "unreadNotificationCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class3.prototype, "unreadNotificationCount"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "notificationCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class3.prototype, "notificationCount"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "logout", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class3.prototype, "logout"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "sessionExtend", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class3.prototype, "sessionExtend"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "sessionExpiring", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class3.prototype, "sessionExpiring"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "sessionExpired", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class3.prototype, "sessionExpired"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "hideSessionExpiringModal", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class3.prototype, "hideSessionExpiringModal"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "loadSessionData", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class3.prototype, "loadSessionData"), _class3.prototype)), _class3);
exports.default = SessionStore;